import React from 'react';
import GlassWorkspaceShell from '../Glass/GlassWorkspaceShell';

/**
 * Procure Budgets workspace chrome (yellow frosted glass).
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
const BudgetsWorkspaceShell = ({ children }) => (
  <GlassWorkspaceShell theme="yellow" wide>
    {children}
  </GlassWorkspaceShell>
);

export default BudgetsWorkspaceShell;
